import { useContext, useEffect } from "react";

import FoundryClient from "../lib/foundry_client/FoundryClient";
import FoundryPhysicalProduct from "../lib/foundry_client/models/FoundryPhysicalProduct";
import { PhysicalProductsContext } from "../contexts/PhysicalProductsContext";

export default function usePhysicalProducts(
  defaultPhysicalProducts?: FoundryPhysicalProduct[]
) {
  const { physicalProducts, setPhysicalProducts } = useContext(
    PhysicalProductsContext
  );

  useEffect(() => {
    if (!setPhysicalProducts) {
      return;
    }

    if (defaultPhysicalProducts) {
      setPhysicalProducts(defaultPhysicalProducts);
    } else if (physicalProducts.length === 0) {
      FoundryClient.getPhysicalProducts().then((products) => {
        setPhysicalProducts(products);
      });
    }
  }, [setPhysicalProducts]);

  return physicalProducts;
}
